import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/quotation_pendings',
    name: 'QuotationPending',
    component: {
      name: 'AdminQuotationPendings',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'quotation_pending',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminQuotationsPendingIndex',
        component: () => import('../views/QuotationsIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminQuotationPendingNew',
        component: () => import('../views/QuotationInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminQuotationsPendingIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminQuotationPendingShow',
        component: () => import('../views/QuotationShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminQuotationsPendingIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminQuotationPendingDetails',
            component: () => import('../views/QuotationDetails.vue'),
            meta: {
              backRoute: { name: 'AdminQuotationsPendingIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminQuotationPendingEdit',
            component: () => import('../views/QuotationInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminQuotationPendingDetails' },
            },
          },
          {
            path: 'attachments',
            name: 'AdminQuotationPendingAttachments',
            component: () => import('../views/attachment/QuotationAttachments.vue'),
            meta: {
              backRoute: { name: 'AdminQuotationsPendingIndex' },
              resource: 'attachment',
            },
          },
          {
            path: 'phases',
            name: 'AdminQuotationPendingPhases',
            component: () => import('../views/QuotationPhases.vue'),
            meta: {
              backRoute: { name: 'AdminQuotationsPendingIndex' },
              resource: 'phase',
            },
          },
          {
            path: 'logs',
            name: 'AdminQuotationPendingLogs',
            component: () => import('../views/QuotationLogs.vue'),
            meta: {
              backRoute: { name: 'AdminQuotationsPendingIndex' },
              resource: 'log',
            },
          },
        ],
      },
    ]
  },
];
OCRoutes.forEach(route => router.addRoute('OC', route));
